import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
//models

import { ComboturmaMedicinaModel } from './../../../providers/model/combo-turma-Medicina.model';
import { DisciplinaMedicinaModel } from './../../../providers/model/disciplina-medicina.model';
import { SubDisciplinaMedicinaModel } from './../../../providers/model/sub-disciplina-medicina.model';
//services

import { AvaliacaoMedicinaModel } from './../../../providers/model/avaliacao-medicina.model';
import { ConsultaMedicinaService } from '../../../providers/service/medicina/consulta-medicina.service';
import { Subscription } from 'rxjs/Subscription';
export class ConsultaMedicinaComponent implements OnInit {

  subscription: Subscription;
public habilitarCarregando: boolean = false;
public codigoEmpresa:number;
public codigoInstituicao:number;
public rgmAluno:number;
public codigoAluno:number;
public codigoTurma:number;
public listaCombo: ComboturmaMedicinaModel[];
public listaDisciplina: DisciplinaMedicinaModel[];
public listaSubDisciplina: SubDisciplinaMedicinaModel[];
public listaAvaliacoes: AvaliacaoMedicinaModel[] = new Array<AvaliacaoMedicinaModel>();
public turmaSelecionada: any;
/**
 * @param {?} consulta
 * @param {?} rotaAtivada
 */
constructor(private consulta:ConsultaMedicinaService,
private rotaAtivada: ActivatedRoute) { }
/**
 * @return {?}
 */
ngOnInit() {
    this.rotaAtivada.params.subscribe(p =>{
      this.codigoEmpresa = p['codigoEmpresa'];
      this.codigoInstituicao = p['codigoInstituicao'];
      this.rgmAluno = p['rgmAluno'];
      this.codigoAluno = p['codigoAluno'];

      this.buscaCombo();
    });
  }
/**
 * @return {?}
 */
public buscaCombo() {
    return this.consulta.getCombo(this.codigoInstituicao, this.rgmAluno, this.codigoEmpresa)
      .subscribe((element: ComboturmaMedicinaModel[]) => {
        this.listaCombo = element;
      });
  }
/**
 * @param {?} item
 * @return {?}
 */
public changeCombo(item: any) {
    this.codigoTurma = item;
    this.buscaDisciplina(this.codigoInstituicao, this.codigoAluno, this.codigoTurma);
  }
/**
 * @param {?} codigoInstituicao
 * @param {?} codigoAluno
 * @param {?} codigoTurma
 * @return {?}
 */
public buscaDisciplina(codigoInstituicao: number, codigoAluno: number, codigoTurma: number) {
    this.consulta.getDisciplinas(codigoInstituicao, codigoAluno, codigoTurma)
      .subscribe(

        (retornoDisciplina: DisciplinaMedicinaModel[]) => {
          this.habilitarCarregando = false;
          retornoDisciplina.forEach(element => {
            if (!element.descricao) {
              element.descricao = "Sem resultado"
            }
          });

          this.listaDisciplina = retornoDisciplina;
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao montar disciplinas", error)
        }
    )
  }
/**
 * @param {?} item
 * @return {?}
 */
public linhaSelecionada(item: DisciplinaMedicinaModel) {
    this.consulta.getSubDisciplinas(item.codigoDisciplina, item.idOferta,  this.codigoAluno, this.codigoInstituicao, this.codigoTurma)
      .subscribe(
        (element: SubDisciplinaMedicinaModel[]) => {
          this.habilitarCarregando = false;
          this.listaSubDisciplina = element;

          for(let /** @type {?} */ subDisciplina of this.listaSubDisciplina){
            for(let /** @type {?} */ avaliacao of subDisciplina.avaliacoes){
              this.listaAvaliacoes.push(avaliacao);
            }
          }
        },
        error => {
          this.habilitarCarregando = false;
          this.subscription.unsubscribe();
          console.log("Erro ao buscar sub disciplinas e avaliações", error)
        }
    )
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-consulta-medicina',
  template: `
    <div style="text-align:center">
      <h1>
        Nota Medicina
      </h1>
    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <label for="comboTurma">Turma</label>
          <select class="form-control" id="comboturma" name="ComboTurma" [(ngModel)]="turmaSelecionada" (change)="changeCombo($event.target.value)">
            <option *ngFor="let item of listaCombo" [value]="item.codigoTurma">{{item.descricao}}</option>
          </select>
        </div>
      </div>
      <br>

      <div class="panel panel-default">
        <!-- Default panel contents -->
        <div class="table-responsive"></div>

        <!-- Table -->
        <table id="tableDisciplina" class="table table-bordered">
          <thead>
            <th>Disciplina</th>
            <th>Notas Parciais</th>
            <th>Nota Final</th>
            <th>Resultado</th>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaDisciplina">
              <td>{{item.descricao}}
                <div id="accordion">
                  <div class="card">
                    <div #someInput id="collapse-{{item.codigoDisciplina}}" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                      <div class="card-body">
                        <h4>
                          Avaliações/Atividades
                        </h4>

                        <table class="table table-bordered">
                          <th>
                            Descrição
                          </th>
                          <th>
                            Nota
                          </th>
                          <tr *ngFor="let subDisciplina of listaSubDisciplina">
                            <td>
                              {{subDisciplina.descricaoSubDisciplina}}
                            </td>
                            <td>
                              {{subDisciplina.mediaFinal}}
                            </td>
                          </tr>
                        </table>
                   
                        <table class="table table-bordered">
                            <th>
                              Descrição
                            </th>
                            <th>
                              Nota
                            </th>
                            <tr *ngFor="let avaliacao of listaAvaliacoes">
                              <td>
                                {{avaliacao.descricao}}
                              </td>
                              <td>
                                {{avaliacao.notaDis}}
                              </td>
                            </tr>
                        </table>

                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td (click)="linhaSelecionada(item)">
                <button type="button" class="btn btn-link" title="Select Financial Instrument" data-toggle="collapse" [attr.data-target]="'#collapse-' + item.codigoDisciplina"
                  aria-expanded="true" aria-controls="collapseOne" [attr.aria-labelledby]="'#heading-'+ item.codigoDisciplina">
                  <span class="glyphicon glyphicon-triangle-bottom" aria-hidden="true"></span>
                </button>
                Ver detalhes
              </td>
              <td>{{item.medFina}}</td>
              <td>{{item.resultado}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div style="text-align:center">
      <p align="center" class="tabela_atencao" style="width:500px; padding:3px">
        <span class="texto04_vermelho">S/N - Sem Nota Processada
          <br> Extrato para simples conferência, sujeito a alteração. Documento não oficial.
        </span>
      </p>
    </div>
  `,
  styles: [`
    th {
        background-color: #DBEBFF;
        border: 1px solid #A4BED4;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 13px;
        color: #006699;
        font-weight: bold;
        text-align: center;
        cursor: default;
    }

    td{
        border: 1px solid #cccccc;
        font-family: Verdana, Arial, Helvetica, sans-serif;
        font-size: 13px;
    }

    .tabela_atencao {
        border: 1px solid #FFCC00;
        background-color: #FFF8D9;
        font: 12px Verdana, Arial, Helvetica, sans-serif;
        color: #CC0000;
        text-align: center;
    }
  `],
  providers:[ConsultaMedicinaService]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConsultaMedicinaService, },
{type: ActivatedRoute, },
];
}

function ConsultaMedicinaComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConsultaMedicinaComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConsultaMedicinaComponent.ctorParameters;
/** @type {?} */
ConsultaMedicinaComponent.prototype.subscription;
/** @type {?} */
ConsultaMedicinaComponent.prototype.habilitarCarregando;
/** @type {?} */
ConsultaMedicinaComponent.prototype.codigoEmpresa;
/** @type {?} */
ConsultaMedicinaComponent.prototype.codigoInstituicao;
/** @type {?} */
ConsultaMedicinaComponent.prototype.rgmAluno;
/** @type {?} */
ConsultaMedicinaComponent.prototype.codigoAluno;
/** @type {?} */
ConsultaMedicinaComponent.prototype.codigoTurma;
/** @type {?} */
ConsultaMedicinaComponent.prototype.listaCombo;
/** @type {?} */
ConsultaMedicinaComponent.prototype.listaDisciplina;
/** @type {?} */
ConsultaMedicinaComponent.prototype.listaSubDisciplina;
/** @type {?} */
ConsultaMedicinaComponent.prototype.listaAvaliacoes;
/** @type {?} */
ConsultaMedicinaComponent.prototype.turmaSelecionada;
/** @type {?} */
ConsultaMedicinaComponent.prototype.consulta;
/** @type {?} */
ConsultaMedicinaComponent.prototype.rotaAtivada;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
